export default {
  data() {
    return {
      numericErrors: {},
    }
  },
  created() {
    this._numericTimers = {}
  },
  methods: {
    numericState(key) {
      return this.numericErrors[key] ? false : null
    },
    numericFeedback(key) {
      return this.numericErrors[key] || ''
    },
    blockNonNumericKeys(event, integerOnly) {
      const blocked = integerOnly
        ? ['e', 'E', '+', '-', '.']
        : ['e', 'E', '+']
      if (blocked.includes(event.key)) event.preventDefault()
    },
    validateNumeric(key, value, min, max, integerOnly) {
      if (this._numericTimers[key]) clearTimeout(this._numericTimers[key])
      this._numericTimers[key] = setTimeout(() => {
        if (value === '' || value === null || value === undefined) {
          this.$set(this.numericErrors, key, '')
          return
        }
        const num = Number(value)
        if (isNaN(num)) {
          this.$set(this.numericErrors, key, `Must be a number (${min} – ${max})`)
        } else if (integerOnly && !Number.isInteger(num)) {
          this.$set(this.numericErrors, key, `Must be a whole number (${min} – ${max})`)
        } else if (num < min || num > max) {
          this.$set(this.numericErrors, key, `Must be between ${min} and ${max}`)
        } else {
          this.$set(this.numericErrors, key, '')
        }
      }, 1000)
    },
  },
  watch: {
    loading(newVal) {
      if (newVal) {
        this.numericErrors = {}
        if (this._numericTimers) {
          Object.values(this._numericTimers).forEach(t => clearTimeout(t))
          this._numericTimers = {}
        }
      }
    }
  },
  beforeDestroy() {
    if (this._numericTimers) {
      Object.values(this._numericTimers).forEach(t => clearTimeout(t))
    }
  }
}
